import { Store } from '@ngrx/store';
import { inject, Injectable } from '@angular/core';
import { PREPAYMENT_PLUGINS_USER_BALANCE_API_ACTIONS } from '@store/prepayment/prepayment.action';

@Injectable({ providedIn: 'root' })
export class PrepaymentStoreDispatcher {
  private readonly store = inject(Store);

  needToDisplayUserBalance(shopId: string) {
    this.store.dispatch(
      PREPAYMENT_PLUGINS_USER_BALANCE_API_ACTIONS.needToDisplayUserBalance({
        shopId,
      }),
    );
  }
}
